module.exports = __webpack_public_path__ + "media/images/gateway/1-746783a368ad46dab1b4943877c38663.png";